import axios from "axios";
import { API_URL } from "../../constants";

export default {
  getAllCount: () => {
    return axios.get(API_URL.SUSCRIPTION_COUNT, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};
